import { useSelector } from 'react-redux';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { UploadedEvidence } from 'src/components/molecules';
import { eventDetailsVm } from 'src/components/pages/Case/Case.slice';
import { hiddenDots } from 'src/components/pages/Case/helpers/hiddenDots';
import { useTheme } from 'styled-components';
import { UploadedEvidenceFile } from '../Reporting/ReportingReport/UploadedEvidence';
import {
  EventDetailsDescription,
  EventDetailsIconContainer,
  EventDetailsTitle,
} from './EventDetailsAccordion.styles';

interface Props {
  uploadedEvidence: UploadedEvidenceFile[];
  reportId: string;
  eventId: string;
  'data-testid'?: string;
}

export const UploadedEvidenceSection = ({
  uploadedEvidence,
  reportId,
  eventId,
  ...props
}: Props) => {
  const theme = useTheme();
  const { noEvidenceUploadedMessage } = useSelector(
    eventDetailsVm({ eventId, reportId }),
  );

  if (uploadedEvidence.length) {
    return (
      <UploadedEvidence
        files={uploadedEvidence}
        reportId={reportId}
        caseManagerView
      />
    );
  }

  const showWarningIcon = noEvidenceUploadedMessage !== hiddenDots;

  return (
    <>
      <EventDetailsTitle>Evidence</EventDetailsTitle>
      {showWarningIcon ? (
        <EventDetailsIconContainer>
          <StyledIcon
            className="uil uil-exclamation-triangle"
            size="24px"
            color={
              theme.isVaultVariant
                ? theme.newPalette.neutral.N900
                : theme.atlas.core.color.gray[950]
            }
            data-testid={`${props['data-testid']}-no-evidence-icon`}
          />
          <EventDetailsDescription>
            {noEvidenceUploadedMessage}
          </EventDetailsDescription>
        </EventDetailsIconContainer>
      ) : (
        <EventDetailsDescription>
          {noEvidenceUploadedMessage}
        </EventDetailsDescription>
      )}
    </>
  );
};
